// extracted by mini-css-extract-plugin
export default {"nav_list":"Sidebar_nav_list__BwHDx"};